<template>
    <div class="py-2">
        <div class="flex items-center pb-1 pr-6"
            :class="{ 'cursor-pointer': ! read_only }"
            @click="toggle"
        >
            <div class="flex flex-none items-center justify-center rounded border mr-3"
                tabindex="0"
                :class="[
                    { 'read_only': read_only },
                    { 'on': selected },
                    { 'off': ! selected },
                    size == 'small' ? 'h-7 w-7' : 'h-10 w-10',
                ]"
                @keydown.space.prevent="toggle"
            >
                <i v-show="selected" class="text-lg text-blue-100 fas fa-check"></i>
            </div>

            <label v-if="label"
                class="font-semibold text-gray-700 text-label leading-none select-none"
                :class="{ 'cursor-pointer': ! read_only }"
                v-html="$t(label)"
            >
            </label>

            <div v-else>
                <slot />
            </div>
        </div>

        <input type="hidden" :name="name" :value="selected" />
    </div>
</template>

<script>
export default {
    props: {
        label: {},
        name: {},
        value: { default: false },
        read_only: { default: false },
        size: { default: 'normal' },
    },

    data() {
        return {
            selected: this.value ? 1 : 0,
        }
    },

    methods: {
        toggle() {
            if (! this.read_only) {
                this.selected = this.selected ? 0 : 1;
                this.$emit('input', this.selected);
            }
        },
    },

    watch: {
        value(val) {
            this.selected = val;
        },
    },
}
</script>

<style scoped>
    .on {
        border-color: #3b82f6;
        background-color: #3b82f6;
    }

    .off {
        border-color: #90b1d5;
        background-color: #ffffff;
    }

    .read_only.on {
        border-color: #4299e1;
        background-color: #4299e1;
    }

    .read_only.off {
        border-color: #f5f5f5;
        background-color: #f5f5f5;
    }

    .accordion .read_only.off {
        border-color: #ffffff;
        background-color: #ffffff;
    }
</style>
